const styles = theme => ({
  subscriptionExplanationContainer: {
    marginTop: theme.spacing(2),
    backgroundColor: "#E5E5E5",
    padding: theme.spacing(3),
    marginBottom: theme.spacing(1)
  },
  subscriptionLeftContainer: {
    marginRight: theme.spacing(3),
    width: "25%"
  },
  subscriptionRightContainer: {
    width: "75%"
  },
  optionLabel: {
    marginBottom: "0px"
  },
  membersContainer: {
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.default
  },
  billedContainer: {
    fontSize: "8px",
    color: theme.palette.primary.default
  },
  priceMonth: {
    color: theme.palette.primary.default
  },
  explanationContainer: {
    marginBottom: theme.spacing(3),
    color: theme.palette.primary.default
  },
  priceExplanationContainer: {
    marginBottom: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    borderBottom: "0.25px solid #95989A"
  },
  totalText: {
    fontWeight: "bold",
    color: theme.palette.primary.default
  },
  couponText: {
    color: theme.palette.primary.default
  },
  agreementsTitle: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.default
  },
  agreementsContainer: {
    backgroundColor: "#E5E5E5",
    padding: theme.spacing(3),
    height: "200px",
    overflowY: "scroll"
  },
  agreementsText: {
    color: theme.palette.primary.default
  },
  checkboxContainer: {
    marginBottom: theme.spacing(3)
  },
  agreemetnsBoxText: {
    color: theme.palette.primary.default
  },
  noAgreemtnsBoxText: {
    color: "#D3D3D3"
  },
  paymentTitle: {
    marginTop: theme.spacing(4),
    color: theme.palette.primary.default
  }
})
export default styles



// WEBPACK FOOTER //
// ./src/pages/OrganizationSignUp/steps/Step4Payment/styles.js